<template>
  <div class="modal" v-if="active" @click.prevent="close">
    <div class="modal-content" @click="onContentClick">
      <button class="close" @click="close">&times;</button>
      <div class="modal-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: Boolean
  },
  methods: {
    close() {
      this.$emit('close')
    },
    onContentClick(e) {
      e.stopPropagation()
    }
  }
}
</script>

<style scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center; 
  align-items: center;
  z-index: 10;
}
.modal.with-backdrop {
  background: rgba(0,0,0,0.2);
}
.modal-content {
  max-width: 90%;
  max-height: 90%;
  display: inline-block;
  position: relative;
}

.modal.padded .modal-content {
  background: #ffffff;
  padding: 2rem;
  border-radius: 4px;
}

.modal-body img {
  width: 100%;
  height: 100%;
  object-position: center;
  object-fit: contain;
}
.close {
  font-weight: 700;
  color: #fff;
  font-style: normal;
  cursor: pointer;
  position: absolute;
  background: none;
  border: none;
  outline: none;
  top: 0.5rem;
  right: 0.5rem;
  font-size: 24px;
}

.modal.padded .close {
  color: #888;
}


@media(min-width: 1024px) {
  .modal-content {
    max-width: 800px;
  }

  .modal.size-md .modal-content {
    width: 600px;
  }
}
</style>